type LandingParallaxShapeProps = {
  variant: 'orbit' | 'squiggle' | 'starburst' | 'connector' | 'blob' | 'ribbon';
  color: string;
};

/**
 * Decorative, scalable whiteboard doodles. The wrapper owns parallax motion;
 * these SVGs never intercept pointer events or render over interactive UI.
 */
export function LandingParallaxShape({ variant, color }: LandingParallaxShapeProps) {
  return (
    <svg data-parallax-shape={variant} viewBox="0 0 400 400" width="100%" height="100%"
      aria-hidden="true" focusable="false" fill="none" xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', pointerEvents: 'none', overflow: 'visible' }}>
      {variant === 'orbit' ? (
        <>
          <ellipse cx="200" cy="200" rx="164" ry="93" transform="rotate(-31 200 200)"
            stroke={color} strokeWidth="12" opacity=".43" />
          <ellipse cx="200" cy="200" rx="164" ry="93" transform="rotate(52 200 200)"
            stroke={color} strokeWidth="4" strokeDasharray="12 15" opacity=".64" />
          <circle cx="80" cy="133" r="19" fill={color} opacity=".5" />
          <circle cx="322" cy="280" r="12" fill={color} opacity=".8" />
          <path d="M300 63v46M277 86h46M115 302v28M101 316h28" stroke={color}
            strokeWidth="7" strokeLinecap="round" />
        </>
      ) : null}
      {variant === 'squiggle' ? (
        <>
          <path d="M42 249C80 185 124 194 121 244c-4 72 90 60 84-17-6-74 92-104 106-29 17 88-55 116-72 68-18-52 42-107 112-87"
            stroke={color} strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" opacity=".55" />
          <path d="M62 305c58 26 94 17 121-2M289 118l14-36m-37 21 34 17"
            stroke={color} strokeWidth="6" strokeLinecap="round" opacity=".7" />
          <circle cx="58" cy="118" r="8" fill={color} />
          <circle cx="339" cy="318" r="12" fill={color} opacity=".5" />
        </>
      ) : null}
      {variant === 'starburst' ? (
        <>
          <path d="m200 42 32 91 92-33-47 82 80 56-96 6-2 102-59-83-72 71 14-99-101-17 87-46-41-92 97 38Z"
            fill={color} fillOpacity=".18" stroke={color} strokeWidth="9" strokeLinejoin="round" />
          <circle cx="201" cy="196" r="31" fill={color} opacity=".67" />
          <path d="m60 330 21-20m-10 9 22 22m236-290 8-24m-20 15 30 11" stroke={color}
            strokeWidth="8" strokeLinecap="round" />
        </>
      ) : null}
      {variant === 'connector' ? (
        <>
          <rect x="45" y="63" width="142" height="82" rx="20" stroke={color} strokeWidth="10" opacity=".76" />
          <rect x="236" y="263" width="128" height="75" rx="23" fill={color} fillOpacity=".15"
            stroke={color} strokeWidth="9" />
          <path d="M115 145v99c0 25 16 40 45 40h63M210 269l18 15-18 15"
            stroke={color} strokeWidth="11" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M194 104h90c28 0 39 17 39 42v63M307 196l16 19 16-19"
            stroke={color} strokeWidth="6" strokeDasharray="12 15" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="115" cy="145" r="10" fill={color} />
          <circle cx="323" cy="209" r="10" fill={color} />
        </>
      ) : null}
      {variant === 'blob' ? (
        <>
          <path d="M202 35C277 13 369 78 357 158c-8 52 32 87-2 151-43 79-114 61-188 50C61 345 34 292 45 212 57 139 104 64 202 35Z"
            fill={color} fillOpacity=".19" stroke={color} strokeWidth="12" opacity=".8" />
          <path d="M107 199c29-42 54 42 89-2 40-51 66-28 99 2"
            stroke={color} strokeWidth="12" strokeLinecap="round" />
          <path d="m100 99 21 15m-3-24-19 24m183 181 24 17m-5-28-19 25"
            stroke={color} strokeWidth="6" strokeLinecap="round" />
          <circle cx="240" cy="110" r="12" fill={color} />
        </>
      ) : null}
      {variant === 'ribbon' ? (
        <>
          <path d="M35 305C77 210 157 338 199 240c36-83-90-118-21-174 52-42 103 51 160 2"
            stroke={color} strokeWidth="40" strokeLinecap="round" opacity=".16" />
          <path d="M35 305C77 210 157 338 199 240c36-83-90-118-21-174 52-42 103 51 160 2"
            stroke={color} strokeWidth="10" strokeLinecap="round" />
          <path d="m290 66 52-3-13 47" stroke={color} strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
          <path d="m82 78 8 31 31 8-31 8-8 31-8-31-31-8 31-8Z"
            fill={color} fillOpacity=".45" />
          <circle cx="318" cy="307" r="14" fill={color} opacity=".6" />
        </>
      ) : null}
    </svg>
  );
}
